<template>
  <transition name="fade" mode="out-in">
    <div key="signup" v-if="!signedup" class="flex flex-col">
      <ValidationObserver ref="emailValidation" tag="form">
        <ValidationProvider rules="required|email" v-slot="{ valid, classes, errors, ariaMsg }" name="Epost">
          <div>
            <input v-model="email" class="bg-white focus:outline-none rounded-l rounded-r-none pt-038 pb-03 px-1 md:px-2 w-48 appearance-none leading-normal text-sm" type="email" placeholder="Din epost">
            <button type="button"
              :disabled="submitting || signedup"
              @click="signup"
              class="bg-cta text-gray-800 pt-038 pb-03 px-1 text-sm md:text-base hover:bg-cta-active md:py-1 md:px-4 rounded-l-none rounded-r"
            >Prenumerera
            </button>
          </div>
          <span v-bind="ariaMsg" class="text-error block">{{ errors[0] || message }}</span>
        </ValidationProvider>
      </ValidationObserver>
    </div>
    <div v-else key="success">
      <span class="text-sm text-white">Tack! Du prenumererar nu på vårt nyhetsbrev.</span>
    </div>
  </transition>
</template>
<script>

  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import axios from 'axios'
  import Bugsnag from '@bugsnag/js'

  export default {
    components: {
      ValidationProvider, 
      ValidationObserver
    },
    data() {
      return {
        email: undefined,
        submitting: false,
        signedup: false,
        message: undefined,
      }
    },
    methods: {
      async signup(e) {
        this.message = undefined
        const valid = await this.$refs.emailValidation.validate(e)
        if(!valid) {
          return false
        }
        const outer = this
        grecaptcha.ready(() => {
          grecaptcha.execute('6LdTUWkfAAAAAHPf1UuSEHDfWgXpjt-jvocc2OuZ', { action: 'newsletter' }).then(async (token) => {
            outer.submitting = true
            try {
              let resp = await axios.post(
                '/wp-json/naturarvet/v1/newsletterSignup',
                { email: outer.email, token: token },
              )
              outer.submitting = false
              if (resp.status === 201) {
                outer.signedup = true
              } else {
                outer.message = "Något gick fel, försök igen eller kontakta oss"
              }

            } catch(e) {
              Bugsnag.notify(e)
              outer.submitting = false
            }
          });
        });
      }
    },
  }
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
